export const PAGINATION_CLASSES = {
  pagination: `
      splide__pagination
    `.trim(),
  page: `
      splide__pagination__page
      appearance-none transition-colors rounded-full
      bg-transparent border-solid border-primary border box-border
      m-0 mx-1 p-0 w-2 h-2
    `.trim(),
};

export const PAGE_CAROUSEL_OPTIONS = {
  autoWidth: true,
  cloneStatus: false,
  drag: true,
  flickMaxPages: 2,
  flickPower: 300,
  lazyLoad: true,
  gap: 0,
  mediaQuery: "min",
  pagination: false,
  speed: 600,
  trimSpace: "move",
  type: "slide",
  updateOnMove: true,

  classes: {
    ...PAGINATION_CLASSES,
  },
} as const;

export const OPAQUE_CLASS = "opacity-100";
export const TRANSPARENT_CLASS = "opacity-0";
export const SLIDE_FADE_CLASS = "opacity-30";
export const PAGINATION_ACTIVE_CLASS = "bg-primary";
export const PAGINATION_INACTIVE_CLASS = "bg-transparent";

export const SPLIDE_EVENT_MOVING = "moving";
export const SPLIDE_EVENT_TRANSITION_COMPLETED = "transitioncompleted";
